module.exports = __webpack_public_path__ + "img/etc.6e52d644.png";